module.exports = __webpack_public_path__ + "static/pic16-2ddcd02a57e24ee40e5cc1c191b913c4.png";